import { Expose } from "class-transformer";

export class UpdateSubtaskDto {
  @Expose()
  name: string;

  @Expose()
  taskTypeId: string;
}
